import { lazy } from 'react';
import { authRoles } from '@/app/auth';

const AddServicePage = lazy(() => import('./AddServicePage'));

const AddServiceConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.ServiceConfig,
  routes: [
    {
      path: 'services/add',
      element: <AddServicePage />,
    },
    {
      path: 'services/:id',
      element: <AddServicePage />,
    },
  ],
};

export default AddServiceConfig;
